import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { Typography, Stack, PaginationItem, Pagination } from '@mui/material';
function index({ totalRows, rowsPerPage = 5, page, handlePageChange, }) {
    const onPageChange = (event, newPage) => {
        handlePageChange(newPage);
    };
    const totalPages = Math.ceil(totalRows / rowsPerPage);
    return (_jsxs(Stack, Object.assign({ direction: "row", justifyContent: "space-between", alignItems: "center", spacing: 4 }, { children: [_jsxs(Typography, Object.assign({ variant: "h5", sx: { fontWeight: 500 } }, { children: ["Showing ", rowsPerPage * page - rowsPerPage + 1, " -", Math.min(rowsPerPage * page, totalRows), " of ", totalRows, " Results"] })), _jsx(Pagination, { count: totalPages, shape: "rounded", size: "small", page: page, onChange: onPageChange, renderItem: (item) => (_jsx(PaginationItem, Object.assign({ component: "button" }, item, { sx: {
                        color: '#505F79',
                        backgroundColor: '#FFFFFF',
                        fontSize: '16px',
                        margin: '0 6px',
                        '&.MuiButtonBase-root': {
                            minWidth: '24px',
                            height: '24px',
                            '&.Mui-selected': {
                                backgroundColor: '#9F92ED',
                            },
                            '&.MuiPaginationItem-firstLast, &.MuiPaginationItem-previousNext': {
                                backgroundColor: 'transparent',
                            },
                        },
                    } }))), boundaryCount: 0, siblingCount: 1, showFirstButton: true, showLastButton: true })] })));
}
export default index;
